module.exports = __webpack_public_path__ + "img/608920f.svg";